import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { BoosterDTO } from '../booster-dtos';

@Component({
  selector: 'app-blaster-form-field',
  templateUrl: './booster-form-field.component.html',
  styleUrls: ['./booster-form-field.component.scss'],
  standalone: false,
})
export class BoosterFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: BoosterDTO;

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public fields: FieldConfigDTO[];

  public canAdd: boolean = false;

  public chanceOfWinning: number;

  public boosterActive: boolean = false;

  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    if (!this.data) {
      this.data = this.getEmptyDTO();
    }
    this.formGroup.get(this.fieldConfig.name).setValue(this.data);

    this.boosterActive = this.data.active;
    this.chanceOfWinning = this.data.chanceOfWinning;

    this.fields = [
      {
        name: 'factor',
        label: 'Factor',
        type: DataType.number,
        editReadOnly: 'true',
      },
      {
        name: 'active',
        label: 'Active',
        type: DataType.checkbox,
      },
    ];
  }

  onValueChanged(value: any[] | any) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    const oldValue: BoosterDTO = formControl.value ? formControl.value : this.getEmptyDTO();

    oldValue.steps = value;
    formControl.setValue(oldValue);
  }

  getData() {
    return this.data.steps.filter((b) => b.factor > 1);
  }

  changeBoosterActive(active: MatSlideToggleChange) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    const oldValue: BoosterDTO = formControl.value ? formControl.value : this.getEmptyDTO();
    oldValue.active = active.checked;
    formControl.setValue(oldValue);
  }

  changeWinningChance(value) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    const oldValue: BoosterDTO = formControl.value ? formControl.value : this.getEmptyDTO();
    oldValue.chanceOfWinning = value;
    formControl.setValue(oldValue);
  }

  private getEmptyDTO(): BoosterDTO {
    return {
      active: true,
      chanceOfWinning: 0,
      steps: [
        {
          factor: 0,
          active: true,
        },
        {
          factor: 2,
          active: true,
        },
        {
          factor: 4,
          active: true,
        },
        {
          factor: 8,
          active: true,
        },
        {
          factor: 16,
          active: true,
        },
        {
          factor: 32,
          active: true,
        },
      ],
    };
  }
}
